/**
 * @file ShopSettingsPage.tsx
 * @description «Магазин» — раздел «Настроек» (phase08.5; phase19.13 — почта
 * магазина; phase19.31 — на Commora: SC52 одна кнопка «Сохранить», SC58
 * часовой пояс, page-analysis-c макет (а)).
 *
 * Заголовок «Магазин» в верхней панели, главное действие одно — «Сохранить»
 * на всю форму, неактивное без изменений (на телефоне и планшете — в общей
 * нижней полосе каркаса). Форма — секции «Основное» (только чтение и пояс),
 * «Контакты для клиентов», «Заказы с сайта»; поля не шире 720px. Заглушка
 * «Юридические реквизиты … phase07+» убрана — реквизиты живут в своём разделе.
 *
 * Данные и сохранение — `useShopSettingsForm`; секции — `ShopSettingsSections`.
 */

import { Button } from "../../components/ui/button";
import { CabinetPageHeader } from "../../components/ui/CabinetPageHeader";
import { ListError } from "../../components/ui/ListStates";
import { Skeleton } from "../../components/ui/skeleton";
import { ShopContactsSection, ShopMainSection, ShopOrdersSection } from "./settings/ShopSettingsSections";
import { useShopSettingsForm } from "./settings/useShopSettingsForm";

export function ShopSettingsPage() {
  const form = useShopSettingsForm();
  const ready = form.settings && form.checkout && form.draft;

  return (
    <div className="flex flex-col gap-6">
      <CabinetPageHeader
        title="Магазин"
        subtitle="Название, контакты и заказы с сайта"
        action={
          <Button variant="brand" onClick={() => void form.save()} disabled={!form.dirty || form.saving || !ready} loading={form.saving}>
            Сохранить
          </Button>
        }
      />

      {form.loading && !ready ? (
        <div className="flex max-w-[45rem] flex-col gap-3" aria-busy="true" aria-label="Загрузка настроек магазина">
          {[0, 1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-11 rounded-lg" />
          ))}
        </div>
      ) : form.loadError || !form.settings || !form.checkout || !form.draft ? (
        <ListError message={form.loadError ?? "Не удалось загрузить настройки магазина."} onRetry={() => void form.reload()} />
      ) : (
        <div className="flex max-w-[45rem] flex-col gap-8">
          <ShopMainSection
            settings={form.settings}
            timeZones={form.timeZones}
            value={form.draft}
            onChange={form.change}
            errors={form.errors}
            disabled={form.saving}
          />
          <ShopContactsSection value={form.draft} onChange={form.change} errors={form.errors} disabled={form.saving} />
          <ShopOrdersSection
            checkout={form.checkout}
            value={form.draft}
            onChange={form.change}
            errors={form.errors}
            disabled={form.saving}
          />
        </div>
      )}
    </div>
  );
}
